import CLink from '../components/CLink.vue';
import {defineNuxtPlugin} from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('CLink', CLink);
});
